/**
 * RouteSelector Component
 * Dropdown for selecting WR routes
 * Requirements: 3.1, 3.3
 */

import { RouteType, RouteSelectorProps } from '../types';
import { getAvailableRoutes, getRouteDefinition } from '../rules/routeRules';
import './RouteSelector.css';

function RouteSelector({ selectedRoute, onRouteChange, disabled = false, variant = 'wr1', id }: RouteSelectorProps) {
  const availableRoutes = getAvailableRoutes();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newRoute = event.target.value as RouteType;
    onRouteChange(newRoute);
  };

  return (
    <div className="route-selector">
      <select
        id={id}
        className={`route-select route-select-${variant}`}
        value={selectedRoute}
        onChange={handleChange}
        disabled={disabled}
      >
        {availableRoutes.map((route) => {
          const definition = getRouteDefinition(route);
          return (
            <option key={route} value={route}>
              {definition?.name ?? route}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default RouteSelector;
